module.exports = __webpack_public_path__ + "img/wool.be5030ca.webp";